"use strict";
/// <reference lib="dom" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @package @wsdot/layer-metadata-soe-client
 */
/** @ignore */
var validLayersUrl = "exts/LayerMetadata/validLayers?f=json";
/** @ignore */
var layerSourcesUrl = "exts/LayerMetadata/layerSources?f=json";
/** @ignore */
var metadataUrl = "exts/LayerMetadata/metadata";
/**
 * An error returned from an ArcGIS service.
 * @example
 * // Inside async function
 * const response = await fetch("https://www.example.com/ArcGIS/rest/services/MyService/query?invalidOption=thisisinvalid");
 * const obj = await response.json();
 * if (obj.error) {
 *  throw new ArcGisError(obj.error);
 * }
 */
var ArcGisError = /** @class */ (function (_super) {
    __extends(ArcGisError, _super);
    /**
     * Creates a new instance of ArcGisError.
     * @param errorInfo - The "error" property of the response object returned from a failed ArcGIS Server request.
     */
    function ArcGisError(errorInfo) {
        var _this = _super.call(this, errorInfo.message) || this;
        _this.errorInfo = errorInfo;
        _this.code = errorInfo.code;
        return _this;
    }
    return ArcGisError;
}(Error));
exports.ArcGisError = ArcGisError;
/**
 * Gets map service info
 * @param serviceUrl map service URL.
 * @throws {ArcGisError}
 */
function getServiceInfo(serviceUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var response, serviceInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch([serviceUrl, "f=json"].join("?"))];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    serviceInfo = (_a.sent());
                    if (serviceInfo.error) {
                        throw new ArcGisError(serviceInfo.error);
                    }
                    return [2 /*return*/, serviceInfo];
            }
        });
    });
}
exports.getServiceInfo = getServiceInfo;
/**
 * Detects if a map service supports the "LayerMetadata" capability.
 * @param serviceUrl Map or Feature service URL.
 * @throws {ArcGisError}
 */
function detectLayerMetadataSupport(serviceUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var serviceInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getServiceInfo(serviceUrl)];
                case 1:
                    serviceInfo = _a.sent();
                    if (!serviceInfo.supportedExtensions) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, /LayerMetadata/.test(serviceInfo.supportedExtensions)];
            }
        });
    });
}
exports.detectLayerMetadataSupport = detectLayerMetadataSupport;
/**
 * Gets a list of data sources
 * @param serviceUrl Map service URL
 * @returns An object keyed by data set names with values that are layer ID integers associated with those datasets.
 */
function getLayerSources(serviceUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, layerSources;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = [serviceUrl, layerSourcesUrl].join("/");
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    layerSources = (_a.sent());
                    return [2 /*return*/, layerSources];
            }
        });
    });
}
exports.getLayerSources = getLayerSources;
/**
 * Gets URLs to unique metadata items.
 * @param url map service URL
 * @param layerSources If you have already called getLayerSources, you can pass in the results here to avoid making a duplicate request.
 * @returns Key value pairs. Keys are table names and values are metadata URLs.
 */
function getMetadataLinks(url, layerSources) {
    return __awaiter(this, void 0, void 0, function () {
        var requestUrl, output, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!layerSources) return [3 /*break*/, 2];
                    return [4 /*yield*/, getLayerSources(url)];
                case 1:
                    layerSources = _a.sent();
                    _a.label = 2;
                case 2:
                    requestUrl = [url, metadataUrl].join("/");
                    output = {};
                    // tslint:disable-next-line:forin
                    for (key in layerSources) {
                        output[key] = [requestUrl, layerSources[key][0]].join("/");
                    }
                    return [2 /*return*/, output];
            }
        });
    });
}
exports.getMetadataLinks = getMetadataLinks;
/**
 * Gets a list of valid layer IDs
 * @param url Map service URL
 * @throws {ArcGisError} Thrown if the map service returns an error.
 * @throws {TypeError} Thrown if HTTP request returns an object in unexpected format.
 */
function getValidLayers(url) {
    return __awaiter(this, void 0, void 0, function () {
        var requestUrl, response, obj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUrl = [url, validLayersUrl].join("/");
                    return [4 /*yield*/, fetch(requestUrl)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    obj = _a.sent();
                    if (obj.layerIds) {
                        return [2 /*return*/, obj.layerIds];
                    }
                    else if (obj.error) {
                        throw new ArcGisError(obj.error);
                    }
                    else {
                        throw new TypeError("response was not expected type: " + JSON.stringify(obj));
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.getValidLayers = getValidLayers;
